
export function supportLink() {
    return "https://t.me/OkiDokiSupportBot"
}

/** Техподдержка в MAX */
export function maxSupportLink() {
    return "https://max.ru/id6330100935_2_bot"
}

export function openInNewTab(url: string) {
    let win = window.open(url, '_blank');
    win?.focus();
}